import { wsService } from "./wsService";
import sections from "@/constants/sections";

const section = sections.SECTION_SUPPLIERS;

//Con el filtro raw en true el listado devuelve filas planas resueltas por SQL, sin objetos de Doctrine
function filter(param = { enable: true }) {
  return wsService.make_post_request(section + "/list", param);
}

//Listado para los combos: id, name, cuit, invoice_expiration e iva_condition
function filterMinify(param = { enable: true }) {
  return wsService.make_post_request(section + "/list-minify", param);
}

//Objeto completo, para los modales de ver/editar
function get(id) {
  return wsService.make_get_request(section + "/get/" + id);
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function update(param = {}) {
  return wsService.make_put_request(section + "/update", param);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}

function list_supplier_bank(param = {}) {
  return wsService.make_post_request(section + "/list_supplier_bank", param);
}

function export_filter(params) {
  return wsService.make_post_request(section + "/export", params, {
    responseType: "arraybuffer",
    headers: {
      Accept: "application/vnd.ms-excel",
    },
  });
}

export const suppliersService = {
  section,
  filter,
  filterMinify,
  get,
  remove,
  create,
  update,
  list_supplier_bank,
  export_filter
};
